// import LeafletMap from "components/map";
import EmpireFilterMap from "components/map/empirefiltermap";

const Map = () => {
    return (
        <>
            <EmpireFilterMap />
        </>
    );
};

export default Map;
